import { defineStore } from 'pinia';
import api from '../api/index.js';

export const useFlowBuilderStore = defineStore('flowBuilder', {
  state: () => ({
    flows: [],
    currentFlow: null,
    executions: [],
    nodeAudience: {},
    metrics: {
      active_flows: 0,
      delivered_messages: { total: 0, recent: 0 },
      orders_revenue: { total: '0', recent: '0' },
      orders_count: { total: 0, recent: 0 },
      window_days: 30,
    },
    metricsLoading: false,
    report: null,
    reportLoading: false,
    attributedOrders: [],
    attributedOrdersMeta: { total_count: 0, current_page: 1, total_pages: 1 },
    attributedOrdersLoading: false,
    loading: false,
    saving: false,
    error: null,
  }),

  actions: {
    async fetchFlows(params = {}) {
      this.loading = true;
      try {
        const { data } = await api.getFlows(params);
        this.flows = data.flows;
      } finally {
        this.loading = false;
      }
    },

    async fetchFlow(flowId) {
      this.loading = true;
      try {
        const { data } = await api.getFlow(flowId);
        this.currentFlow = data;
      } finally {
        this.loading = false;
      }
    },

    async createFlow(flowData) {
      const { data } = await api.createFlow(flowData);
      this.flows.unshift(data);
      return data;
    },

    async saveCurrentFlow(flowData) {
      if (!this.currentFlow) return;
      this.saving = true;
      try {
        const { data } = await api.updateFlow(this.currentFlow.id, flowData);
        this.currentFlow = data;
        const idx = this.flows.findIndex(f => f.id === data.id);
        if (idx !== -1) this.flows[idx] = data;
      } finally {
        this.saving = false;
      }
    },

    async deleteFlow(flowId) {
      await api.deleteFlow(flowId);
      this.flows = this.flows.filter(f => f.id !== flowId);
    },

    async toggleActive(flowId) {
      const { data } = await api.toggleActive(flowId);
      const idx = this.flows.findIndex(f => f.id === flowId);
      if (idx !== -1) this.flows[idx] = data;
      if (this.currentFlow?.id === flowId) this.currentFlow = data;
      return data;
    },

    async fetchExecutions(flowId) {
      const { data } = await api.getExecutions(flowId);
      this.executions = data.executions;
    },

    async fetchNodeAudience(flowId) {
      const { data } = await api.getNodeStats(flowId);
      this.nodeAudience = data.node_stats ?? {};
    },

    async fetchMetrics(params = {}) {
      this.metricsLoading = true;
      try {
        const { data } = await api.getMetrics(params);
        this.metrics = data;
      } finally {
        this.metricsLoading = false;
      }
    },

    async fetchReports(flowId, params = {}) {
      this.reportLoading = true;
      try {
        const { data } = await api.getReports(flowId, params);
        this.report = data;
      } finally {
        this.reportLoading = false;
      }
    },

    async fetchAttributedOrders(flowId, params = {}) {
      this.attributedOrdersLoading = true;
      try {
        const { data } = await api.getAttributedOrders(flowId, params);
        this.attributedOrders = data.orders;
        this.attributedOrdersMeta = data.meta;
      } finally {
        this.attributedOrdersLoading = false;
      }
    },
  },
});
